import { useState } from "react";
import { ListBase, SimpleList, useRecordContext } from "react-admin";
import SubjectIcon from '@mui/icons-material/Subject';
import { Dialog, DialogProps, IconButton } from "@mui/material";



export const ShowConversationForReportButton = (props: any) => {

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const open = Boolean(anchorEl);
    const record = useRecordContext();
    if (record) {
        const users = [record.reporter, record.about];
        return (
            <>
                <IconButton onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    event.preventDefault();
                    setAnchorEl(event.currentTarget)
                }} >
                    <SubjectIcon />
                </IconButton >
                <ConversationsListMenuList users={users}
                    open={open}
                    onClose={() => setAnchorEl(null)} />
            </>)
    }
}



const ConversationsListMenuList = ({ users, ...props }: { users: string[] } & DialogProps) => {

    return (
        <Dialog  {...props}>
            <ListBase resource="conversation" filter={{ users, withDeleted: 1 }} sort={{ field: "id", order: 'DESC' }}>
                <SimpleList primaryText={record => record.id}
                    // secondaryText={record => record.id}
                    tertiaryText={record => new Date(record.lastSent).toLocaleDateString()}
                />
            </ListBase>
        </Dialog>
    )
}

